import React, { useState } from 'react';
import styled from 'styled-components';
import { ChevronDown, ChevronUp } from 'sushiweb/Icons';
import { toast } from 'react-hot-toast';

function Sidebar({ data, changeTab, activeTab }) {
  const [AccessibleTabs, setAccessibleTabs] = useState(data?.tab_groups);

  const openTabGroup = (tabClicked, index) => {
    const updatedAccessibleTabs = AccessibleTabs.map((tabGroup, ind) => {
      if (ind === index) {
        const updatedGroup = {
          ...tabGroup,
          is_collapsed:
            tabGroup.tabs.length > 1 ? !tabGroup.is_collapsed : true,
        };
        return updatedGroup;
      } else {
        const updatedGroup = {
          ...tabGroup,
          is_collapsed: true,
        };
        return updatedGroup;
      }
      return tabGroup;
    });
    setAccessibleTabs(updatedAccessibleTabs);
  };

  const changeSlug = (activetabSlug, tabGroup) => {
    changeTab(activetabSlug);
  };

  const checkActiveTabGroup = (tabGroup) => {
    let isActiveTabGroup = false;
    tabGroup.tabs.every((tab) => {
      if (tab.slug === activeTab) {
        isActiveTabGroup = true;
        return false;
      }
      return true;
    });
    return isActiveTabGroup;
  };

  if (!AccessibleTabs) return null;
  return (
    <SidebarContainer>
      {AccessibleTabs.map((tabGroup, index) => {
        return (
          <TabGroup
            onClick={() => {
              if (tabGroup.tabs.length > 1) return;
              if (!tabGroup?.tabs[0].is_enabled) {
                toast.error('You are not authorized to perform this action');
                return;
              }
              changeSlug(tabGroup?.tabs[0].slug, tabGroup);
            }}
          >
            <MenuTitle
              onClick={() => {
                openTabGroup(tabGroup.display_name, index);
              }}
            >
              <div
                css={`
                  color: ${activeTab.includes(tabGroup.slug) ||
                  checkActiveTabGroup(tabGroup)
                    ? '#318616'
                    : '#696969'};
                  font-weight: 500;
                  font-size: 1.7rem;
                `}
              >
                {tabGroup?.tabs?.length > 1
                  ? tabGroup.display_name
                  : tabGroup?.tabs[0].display_name}
              </div>
              {tabGroup.tabs.length > 1 && (
                <div>
                  {tabGroup.is_collapsed ? (
                    <ChevronDown
                      size={30}
                      color={`${
                        tabGroup.display_name === activeTab ||
                        checkActiveTabGroup(tabGroup)
                          ? '#318616'
                          : '#696969'
                      }`}
                    />
                  ) : (
                    <ChevronUp
                      size={30}
                      color={`${
                        tabGroup.display_name === activeTab ||
                        checkActiveTabGroup(tabGroup)
                          ? '#318616'
                          : '#696969'
                      }`}
                    />
                  )}
                </div>
              )}
            </MenuTitle>
            {tabGroup.tabs.length > 1 &&
              !tabGroup.is_collapsed &&
              tabGroup.tabs.map((tab) => {
                return (
                  <>
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!tab?.is_enabled) {
                          toast.error(
                            'You are not authorized to perform this action',
                          );
                          return;
                        }
                        changeSlug(tab.slug, tabGroup);
                      }}
                      css={`
                        border-left: ${tab.slug === activeTab
                          ? '4px solid #318616'
                          : ''};
                        color: ${tab.slug === activeTab ? '#318616' : ''};
                      `}
                    >
                      {tab.display_name}
                    </MenuItem>
                  </>
                );
              })}
            <hr
              color='#f8f8f8'
              css={`
                margin: 0;
              `}
            />
          </TabGroup>
        );
      })}
    </SidebarContainer>
  );
}

export default Sidebar;

const SidebarContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 25%;
  background: #ffffff;
  box-shadow: 4px 0px 8px rgba(28, 28, 28, 0.05);
  cursor: pointer;
  overflow-y: auto;
  direction: rtl;
`;

const TabGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  direction: ltr;
`;
const MenuItem = styled.div`
  width: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: #f8f8f8;
  color: #696969;
  font-weight: 400;
  font-size: 1.4rem;
  border-left: 4px solid #f8f8f8;
`;

const MenuTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  font-weight: 400;
  font-size: 1.5rem;
`;
